export function openMenu(payload) {
    return { payload, type: 'OPEN_MENU' };
}

export function closeMenu(payload) {
    return { payload, type: 'CLOSE_MENU' };
}
